import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Purity",
    body: "Each lot of Lab2o bacteriostatic water is prepared from high-purity water and contains 0.9% benzyl alcohol as a bacteriostatic preservative. Every batch is filtered and inspected against strict internal specifications before release.",
  },
  {
    num: "02",
    title: "Sterile Packaging",
    body: "Vials are filled, sealed, and crimped under controlled conditions, then packed in protective, contamination-resistant packaging. Tamper-evident seals keep each unit intact from our facility to your laboratory bench. All vials ship unlabeled — bare glass with no branding or markings.",
  },
  {
    num: "03",
    title: "Research Only",
    body: "Lab2o products are supplied exclusively as laboratory research reagents. They are not manufactured, labelled, or sold for any other purpose, and we make no claims beyond their use as research materials.",
  },
];

export default function Manifesto() {
  return (
    <section id="quality" className="py-24 sm:py-32 bg-slate-50 border-y border-slate-200" data-testid="quality-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-plexmono text-[11px] tracking-[0.25em] uppercase text-slate-400 mb-4"
          data-testid="quality-overline"
        >
          02 — Quality Manifesto
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-chivo font-black tracking-tighter text-4xl sm:text-5xl text-slate-950 mb-16"
          data-testid="quality-heading"
        >
          Built for the bench.
        </motion.h2>

        <div className="flex flex-col">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 }}
              className={`grid md:grid-cols-12 gap-6 md:gap-10 py-12 border-t border-slate-200 ${
                i % 2 === 1 ? "md:text-left" : ""
              }`}
              data-testid={`quality-chapter-${c.num}`}
            >
              <div className={`md:col-span-4 ${i % 2 === 1 ? "md:order-2 md:col-start-9" : ""}`}>
                <span className="font-chivo font-black text-7xl sm:text-8xl leading-none text-outline block">
                  {c.num}
                </span>
              </div>
              <div className={`md:col-span-8 ${i % 2 === 1 ? "md:order-1 md:col-start-1" : ""} md:pt-4`}>
                <h3 className="font-chivo font-extrabold tracking-tight text-2xl sm:text-3xl text-slate-950">
                  {c.title}
                </h3>
                <p className="mt-4 max-w-xl text-slate-600 leading-relaxed text-base">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
